import { Star } from "lucide-react";

export function StarDisplay({ value, size = 14, className = "" }) {
  const rounded = Math.round((value || 0) * 2) / 2;
  return (
    <div className={`inline-flex items-center gap-0.5 ${className}`} aria-label={`${value}/5`}>
      {[1, 2, 3, 4, 5].map((n) => {
        const filled = n <= Math.floor(rounded);
        const half = !filled && n === Math.ceil(rounded) && rounded % 1 !== 0;
        return (
          <span key={n} className="relative inline-block" style={{ width: size, height: size }}>
            <Star
              className="absolute inset-0"
              style={{ width: size, height: size, color: "#ddd6c8" }}
              fill="#ddd6c8"
              strokeWidth={0}
            />
            {(filled || half) && (
              <span className="absolute inset-0 overflow-hidden" style={{ width: half ? size / 2 : size }}>
                <Star
                  style={{ width: size, height: size, color: "var(--terracotta)" }}
                  fill="var(--terracotta)"
                  strokeWidth={0}
                />
              </span>
            )}
          </span>
        );
      })}
    </div>
  );
}

export function StarInput({ value, onChange, testId, size = 22 }) {
  return (
    <div className="inline-flex items-center gap-1" data-testid={testId} role="radiogroup">
      {[1, 2, 3, 4, 5].map((n) => {
        const active = n <= value;
        return (
          <button
            key={n}
            type="button"
            role="radio"
            aria-checked={active}
            aria-label={`${n} star${n === 1 ? "" : "s"}`}
            data-testid={`${testId}-${n}`}
            onClick={() => onChange(n)}
            className="transition-transform hover:scale-110 focus:outline-none"
          >
            <Star
              style={{
                width: size, height: size,
                color: active ? "var(--terracotta)" : "#ddd6c8",
              }}
              fill={active ? "var(--terracotta)" : "#ddd6c8"}
              strokeWidth={0}
            />
          </button>
        );
      })}
    </div>
  );
}
